export function parseMfaError(error) {
    if (error instanceof Error) {
        try {
            const parsed = JSON.parse(error.message);
            if (parsed?.data?.multiFactors) {
                return parsed.data.multiFactors;
            }
        }
        catch {
            // ignore JSON parse failures
        }
    }
    return null;
}
//# sourceMappingURL=parseMfaError.js.map